export enum ExperimentBatchChannel {
  SPLIT_ID = 'SPLIT_ID',
  USER_ID = 'USER_ID',
}

export type ExperimentBatchItem = { name: string; group: string };

export type ExperimentBatchQueue = Record<ExperimentBatchChannel, Array<ExperimentBatchItem>>;

export type ExperimentFlushTimer = Record<ExperimentBatchChannel, NodeJS.Timeout | null>;

export type ExperimentTrackingParams = { experimentName: string; groupName: string };
